

Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidInputType = void 0;
function isValidInputType(cardNumber) {
    return typeof cardNumber === "string" || cardNumber instanceof String;
}
exports.isValidInputType = isValidInputType;


//////////////////
// WEBPACK FOOTER
// ../node_modules/credit-card-type/dist/lib/is-valid-input-type.js
// module id = ../node_modules/credit-card-type/dist/lib/is-valid-input-type.js
// module chunks = 0